import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function AuthShell() {
  return (
    <div className="max-w-7xl mx-auto flex items-center justify-between px-6 pt-6 lg:px-12">
        <Link
          to="/"
          aria-label="ordrs home"
          className="brand-wordmark text-2xl leading-none text-foreground"
        >
          ordrs
        </Link>
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 text-sm font-medium text-muted-foreground transition-colors hover:text-foreground"
        >
          <ArrowLeft className="h-3.5 w-3.5" aria-hidden="true" />
          Back to site
        </Link>
    </div>
  );
}
